import BasketApi from "../Api/basket-api";
import {notice} from "../UI/notice";

export const getCartData = async (coupon , paymentVariant) => {
    try {
        let response = await BasketApi.cartData(coupon.trim(), paymentVariant);
        let result = await response.json();
        if (result.success) {
            return result;
        }
        notice(response.message);
    } catch (e) {
        notice(e.message);
        return null;
    }
};